import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { MissionSection } from './components/MissionSection';
import { ProcessSection } from './components/ProcessSection';
import { CostBreakdown } from './components/CostBreakdown';
import { ServicesSection } from './components/ServicesSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { CarFinderPage } from './pages/CarFinderPage';
type Page = 'home' | 'car-finder';
export function App() {
  const [currentPage, setCurrentPage] = useState<Page>('home');
  const navigateTo = (page: string) => {
    setCurrentPage(page as Page);
    window.scrollTo(0, 0);
  };
  return <div className="min-h-screen bg-earia-bg text-earia-text-heading font-sans selection:bg-earia-accent selection:text-earia-text-heading" data-id="element-0">
      {currentPage === 'home' ? <>
          <Navbar onNavigate={navigateTo} data-id="element-1" />
          <main data-id="element-2">
            <HeroSection onNavigate={navigateTo} data-id="element-3" />
            <ProblemSection data-id="element-4" />
            <ProcessSection data-id="element-5" />
            <CostBreakdown data-id="element-6" />
            <ServicesSection data-id="element-7" />
            <MissionSection data-id="element-8" />
            <FAQSection data-id="element-9" />
            <CTASection data-id="element-10" />
          </main>
          <Footer data-id="element-11" />
        </> : <CarFinderPage onBack={() => navigateTo('home')} data-id="element-12" />}
    </div>;
}